import { OWebPageBase } from "oweb";
import PUserLoginComponent from "@/components/pages/oweb/PUserLogin.vue";
import { VueConstructor } from 'vue';

export default class PUserLogin extends OWebPageBase<VueConstructor> {
	getName() {
		return "PUserLogin"
	}

	getRoutes() {
		return [ {
			title: "OO_LANG_LOGIN",
			path: "/login",
			show: () => false
		} ]
	}

	getComponent() {
		return PUserLoginComponent;
	}
}